import * as swcHelpers from '@swc/helpers';
import { toBaseLineItem } from './base-line-item.js';

const toSolutionOrderLineItem = (lineItem, intl, options = {})=>{
    return swcHelpers.objectSpread({}, toBaseLineItem(lineItem, intl, options), {
        type: 'SOLUTION',
        isSubscription: lineItem.isSubscription,
        subscriptionDetails: lineItem.subscriptionDetails ? {
            deliveryInterval: lineItem.subscriptionDetails.deliveryInterval
        } : undefined
    });
};

export { toSolutionOrderLineItem };
//# sourceMappingURL=solution-line-item.js.map
